import service from './service';

export default {
  // 获取PC模板
  getWebPcVer() {
    return service.get(`/api/v1/web/pc/version`);
  },
  // 获取网站配置
  getWebConfig() {
    return service.get(`/api/v1/web/config`);
  },
  // 获取网站开关配置
  getSwitchList() {
    return service.get(`/api/v1/web/switch/1`);
  },
  // 获取导航信息
  getNavigation() {
    return service.get(`/api/v1/web/navigation`);
  },
  // 获取数字验证图片
  getCaptcha() {
    return service.get('/api/v1/captcha/image2?len=4');
  },
  // 获取数字验证图片
  collateSmscode(data) {
    return service.post('/api/v1/captcha/image', data);
  }
};



// WEBPACK FOOTER //
// ./src/api/web-config.js